import React, { useState } from "react";
import ViewReverse from "./ViewReverse";
import ViewItems from "./ViewItems";
import { ReactSVG } from "react-svg";
import icons from "../constants/icons";
import Text from "./Text";
import { fontSizes } from "../constants/constants";
import dynamicfunction from "../utils/dynamicfunction";
import { MenuItem, Select } from "@mui/material";
import { alertOptions } from "../config/config";
import { getContentKeyAccToLang } from "../utils/utils";
import { useSelector } from "react-redux";

const AlertListView = ({
  id,
  symbol,
  symbolCode,
  condition,
  value,
  expiryDate,
  statusId,
  handleModify,
  handleDelete,
}) => {
  const { TextWeight, isArabic } = dynamicfunction();
  const [isOptions, setIsOptions] = useState(false);

  const { settingContent } = useSelector((state) => state.content);

  const getContentKey = (key) => {
    return getContentKeyAccToLang(
      settingContent?.web_alert?.data?.attributes,
      key,
      isArabic
    );
  };

  const remainingDays = Math.floor(
    (new Date(expiryDate).getTime() - new Date().getTime()) /
      (1000 * 60 * 60 * 24)
  );

  const toogleOptionsDropdown = () => setIsOptions(!isOptions);

  return (
    <ViewReverse
      className={
        "w-full justify-between pt-4 pb-2 sm:px-5 overflow-hidden border-b border-b-grey"
      }
    >
      <ViewItems className={"w-1/2"}>
        <ViewReverse>
          <Select
            open={isOptions}
            onOpen={toogleOptionsDropdown}
            onClose={toogleOptionsDropdown}
            onChange={(e) => {}}
            inputProps={{ "aria-label": "Without label" }}
            displayEmpty
            className="w-fit"
            sx={{
              ".MuiOutlinedInput-notchedOutline": {
                borderColor: "transparent",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "transparent",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "transparent",
              },
              ".MuiSelect-select": {
                padding: 0,
              },
              padding: 0,
              width: 20,
            }}
            renderValue={() => (
              <ReactSVG src={icons.dots} className="w-1 mx-auto" />
            )}
            MenuProps={{
              MenuListProps: {
                sx: {
                  py: 0,
                },
              },
            }}
            IconComponent={null}
          >
            {alertOptions?.map((item) => (
              <MenuItem
                key={item?.id}
                value={item.id}
                onClick={() => {
                  item?.key === "modify" ? handleModify() : handleDelete();
                }}
                sx={{
                  justifyContent: isArabic ? "flex-end" : "flex-start",
                  padding: 0,
                  transition: "all 0.3s ease",
                }}
              >
                <Text
                  size={fontSizes.h14}
                  text={getContentKey(item?.label)}
                  className={"w-full border-b border-b-black/20 py-3 px-4"}
                />
              </MenuItem>
            ))}
          </Select>
          <ViewItems>
            <Text
              text={symbol}
              size={fontSizes.h14}
              weight={TextWeight.light}
              color="text-dark-blue"
              isTruncate={false}
            />
            <Text
              text={symbolCode}
              weight={TextWeight.light}
              color="text-light-blue"
              className={"mt-1"}
            />
          </ViewItems>
        </ViewReverse>
      </ViewItems>

      <ViewItems className={"w-1/2 items-end"}>
        <Text
          text={`${condition} ${value}`}
          size={fontSizes.h14}
          weight={TextWeight.light}
          color="text-dark-blue"
          align={isArabic ? "text-left" : "text-right"}
          isTruncate={false}
        />
        {statusId != 3 && (
          <Text
            text={`${remainingDays} Remaining days`}
            weight={TextWeight.light}
            color="text-black/60"
          />
        )}
      </ViewItems>
    </ViewReverse>
  );
};

export default AlertListView;
